import React, { useState } from 'react';
import { StepContainer, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { ReferenciasInfo } from '../sections';

export const Step19_ReferenciaFamiliar1: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.referenceNameOne) newErrors.referenceNameOne = 'Nome da referência é obrigatório';
    if (!data.referencePhoneOne) newErrors.referencePhoneOne = 'Telefone da referência é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ referenceNameOne: data.referenceNameOne, referencePhoneOne: data.referencePhoneOne });
  };

  const handleFieldChange = (newData: Partial<typeof data>) => {
    // Mapear dados da seção ReferenciasInfo para os campos do contexto
    if ('name' in newData) {
      updateField('referenceNameOne', newData.name);
    }
    if ('phone' in newData) {
      updateField('referencePhoneOne', newData.phone);
    }
    
    Object.keys(newData).forEach(key => {
      if (errors[key]) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[key];
          return newErrors;
        });
      }
    });
  };

  return (
    <StepContainer title="Ref. Familiar 1:">
      <div className="mb-6">
        <p className="font-semibold mb-2">Agora, vamos as 2 referências familiares.. (exemplos: pai, mãe, irmã(o), esposo(a)...)</p>
        
        <p className="text-muted-foreground text-sm mb-4">
          ⚠️ Essas referências são uma forma de segurança no processo de consignado e também podem ser usadas para ações especiais, como entrega de brindes surpresa, campanhas de reconhecimento e bonificações especiais. 💝
        </p>

        <p className="text-sm mb-4">
          Referência 1 - preencha nome e grau de parentesco
        </p>

        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
          <p className="text-amber-900 text-sm">
            Por exemplo: <span className="font-semibold">Ana - irmã</span>
          </p>
        </div>
        
      </div>
      <ReferenciasInfo
        numero={1}
        data={{
          name: data.referenceNameOne || '',
          phone: data.referencePhoneOne || '',
        }}
        onChange={handleFieldChange}
      />

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step19_ReferenciaFamiliar1;
